import { StyledModal } from '@app/components/modal/Modal';
import useNumberActions from '@app/hooks/numbers/useNumberActions';
import type { AINumber } from '@app/services/number.types';
import type { ModalProps } from 'antd';
import { NumberForm } from './NumberForm';

export type NumberAddModalProps = ModalProps & {
	title?: string;
	data?: AINumber;
};

export const NumberAddModal = ({
	title = 'New Phone Number',
	data,
	onOk,
	...props
}: NumberAddModalProps) => {
	const { addNumber } = useNumberActions();

	// Reset the component if closed
	if (!props.open) {
		return null;
	}

	return (
		<StyledModal title={title} footer={null} {...props}>
			<NumberForm
				id="ai-number-add"
				data={data}
				onCancel={props.onCancel}
				loading={addNumber.isPending}
				onSubmit={(values) => {
					const formData = {
						...values,
					};
					addNumber.mutate(formData, {
						onSuccess: () => {
							if (onOk) {
								onOk(undefined as unknown as React.MouseEvent<HTMLButtonElement>);
							}
						},
					});
				}}
			/>
		</StyledModal>
	);
};
